import type { ReactElement } from 'react';

type Props = {
    id: string | undefined;
    name: string | undefined;
};

/**
 * Customer identity as a single text run: ERP ID first in a muted, lighter weight, then the
 * name in whatever the surrounding `Text` sets. Drops in wherever a bare customer name was.
 */
export function CustomerIdName({ id, name }: Props): ReactElement {
    return (
        <>
            {id ? (
                <span className="text-neutral-500 font-normal text-[0.9em] tabular-nums">{id}</span>
            ) : undefined}
            {id && name ? ' ' : undefined}
            {name}
        </>
    );
}
